// extracted by mini-css-extract-plugin
export default {"topback":"index_topback_dW1Fr"};